import actions from "./actions";

const updateAlert = actions.updateAlert;
const resetAlert = actions.resetAlert;

export default {
  updateAlert,
  resetAlert,
};
